let amountUtils = {
  transform(money){
    if(!money){
      return "0.00";
    }
    money = money.toString();
    if(money.length < 3){
      return money/100;
    }
    let integer = money.substring(0, money.length-2);
    let decimal = money.substring(money.length-2, money.length);
    return integer+"."+decimal;
  },
  cutDecimal (num, reserve) {
      let numStr = num.toString();
      let integer = numStr.substring(0, numStr.lastIndexOf("."));
      let decimals = numStr.substring(numStr.lastIndexOf("."), numStr.length);
      reserve+=1;
      if (decimals.length <= reserve) {
          return num;
      }
      return integer+decimals.substr(0, reserve);
  }
}

let dateUtils = {
    getYear(date){
        return new Date(date).getFullYear().toString();
    },
    getMonth(date){
        let dateObj = new Date(date);
        let result = dateObj.getMonth()+1;
        return result<10?"0"+result:result;
    },
    getDay(date){
        let dateObj = new Date(date);
        let result = dateObj.getDate();
        return result<10?"0"+result:result;
    },
    getReportDate(date){
        return this.getMonth(date)+"-"+this.getDay(date);
    },
    cutTime(date){
        if(!date){return date;}
        return date.substr(0, 10);
    },
    formatMinutes(minutes){
        let hours = parseInt(minutes/60);
        hours = hours<10?"0"+hours:hours;
        let newMinutes = (minutes%60);
        return hours+":"+(newMinutes<10?"0"+newMinutes:newMinutes);
    }
}

let uriUtils = {
    goto (pageUri, params){
      let uri = pageUri;
      let isFirst = true;
      for(let key in params){
        if(isFirst){
          uri+="?";
          isFirst = false;
        }else{
          uri+="&";
        }
        uri = uri+key+"="+params[key];
      }
      location = uri;
    },
    //返回一个map，如果参数为空则将所有参数转化成map
    getParameter(...names){
        let search = location.search;
        search = search.substr(1, search.length);
        let params = search.split("&");
        let map = new Map();
        params.forEach((val)=>{
          let param = val.split("=");
          let paramName = param[0];
          let paramVal = param[1]||"";
          if(names&&names.length>0&&names.indexOf(paramName) == -1){
            return;
          }
          map.set(paramName, paramVal);
        });
        return map;
    }
}
let mixins={methods:Object.assign({},amountUtils,dateUtils)};
export {amountUtils, dateUtils, uriUtils};
export {mixins}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js